module.exports = __webpack_public_path__ + "合作8.png?9a6ecce2419d270910dfbfb114c04e4d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/合作8.png
// module id = 650
// module chunks = 0